import "./Input.scss";

import {
  Container,
  IconButton,
  InputAdornment,
  TextField
} from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  handleSendMessage,
  handleSignIn,
  setBotsMenuOpen,
  setInputMessage
} from "../redux/chatSlice";
import { useDispatch, useSelector } from "react-redux";

import { Send as SendIcon } from "@mui/icons-material";
import { getNextMessage } from "../utils/Functions";
import { messageSent } from "../segment/Events";

function Input() {
  const dispatch = useDispatch();
  const inputMessage = useSelector((state) => state.chat.inputMessage);
  const isLoading = useSelector((state) => state.chat.isLoading);
  const user = useSelector((state) => state.chat.user);
  const bot = useSelector((state) => state.chat.bot);
  const trialMessages = useSelector((state) => state.chat.trialMessages);

  const [iPhoneStandalone, setIPhoneStandalone] = useState(false);

  useEffect(() => {
    const isInStandaloneMode = () =>
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    if (isInStandaloneMode() && /iPhone|iPad|iPod/i.test(navigator.userAgent)) {
      setIPhoneStandalone(true);
    }
  }, []);

  const trialOver = !user && trialMessages.length >= 5;

  return (
    <div
      className={`input ${user ? "input-user" : "input-noUser"} ${
        iPhoneStandalone ? "input-iPhoneStandalone" : ""
      }`}
      onClick={() => dispatch(setBotsMenuOpen(false))}
    >
      <Container>
        <TextField
          fullWidth
          value={inputMessage}
          onChange={(e) => dispatch(setInputMessage(e.target.value))}
          onKeyDown={(e) => {
            if (e.key === "Enter") {
              if (!trialOver) {
                dispatch(
                  handleSendMessage({
                    message: inputMessage,
                    user,
                    free: false
                  })
                );
                messageSent(inputMessage, bot.id, false);
              }
            }
          }}
          placeholder="Type a message..."
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => {
                    if (!trialOver) {
                      dispatch(
                        handleSendMessage({
                          message: inputMessage,
                          user,
                          free: false
                        })
                      );
                      messageSent(inputMessage, bot.id, false);
                    } else {
                      dispatch(handleSignIn());
                    }
                  }}
                  disabled={isLoading}
                >
                  <SendIcon sx={{ color: "#e0e0e0" }} />
                </IconButton>
              </InputAdornment>
            )
          }}
          sx={{
            "& .MuiOutlinedInput-root": {
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent"
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent"
              },
              "&:disabled .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent"
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "transparent"
              }
            }
          }}
        />
      </Container>
      {!user && (
        <div
          className="input-trialContainer"
          onClick={() => dispatch(handleSignIn())}
        >
          <div className="input-trialRemaining">
            {`${5 - trialMessages.length} message${
              trialMessages.length !== 1 ? "s" : ""
            } remaining${getNextMessage(trialMessages)}`}
          </div>
          <div className="input-trialLogin">
            Create your free account or login for unlimited messages
          </div>
        </div>
      )}
    </div>
  );
}

export default Input;
